"use client"


import {useTranslations} from "use-intl";
import useLocalStorage from "@/core/utils/localStorage";
import {ENGLISH_APP, LOGIN_STATE_KEY, SCORE_STATE_KEY} from "@/core/services/CONSTANTS";
import {useEffect} from "react";
import {Column} from "@/core/general/column.component";
import {
    COIN_DRAWER_FRAME_IMAGE, COIN_IMAGE,
    DRAWER_FRAME_IMAGE, USER_FAVORITE_IMAGE,
    USER_LOGIN_IMAGE,
    USER_LOGOUT_IMAGE,
    USER_PROFILE_FILL_IMAGE, USER_SETTING_IMAGE
} from "@/core/tools/profile/CONSTANTS";
import {Row} from "@/core/general/row.component";
import {getPhoneNumber} from "@/core/services/localStorage.service";
import {toPersianNumber, toPersianNumberFromNumber} from "@/core/utils/number.utils";
import {TitleImageRowComponent} from "@/core/general/titleImageRowComponent";
import {FAVORITE, SETTING} from "@/core/navigation/CONSTANTS";
import {useDispatch} from "react-redux";
import {AppDispatch} from "@/core/redux/store";
import {EXCHANGE_RATE_PATH} from "@/core/CONSTANTS";
import {ExchangeRateResponse} from "@/core/tools/exchange_rate/model/exchangeRate.model";
import {loginState, logoutState} from "@/core/reducer/loginReducer";
import {LOGIN_STATE, LOGOUT_STATE} from "@/core/reducer/CONSTANTS";
import {useRouter} from "next/navigation";

interface ProfileProps {
    closeDrawer: () => void;
}

export default function Profile(props: ProfileProps){

    const t = useTranslations();
    const router = useRouter();

    const [isLogin, setLogin] = useLocalStorage<boolean>(LOGIN_STATE_KEY, false);
    const [userScore, setUserScore] = useLocalStorage<string>(SCORE_STATE_KEY, "0");
    const dispatch = useDispatch<AppDispatch>();

    async function getScore() {
        const data = await fetch(`${process.env.NEXT_PUBLIC_API_ENDPOINT}${EXCHANGE_RATE_PATH}`, {
            method: "GET",
            headers: {
                'App-Version': `70000000`,
                'App-Package': process.env.NEXT_PUBLIC_PACKAGE ?? '',
                'Content-Type': 'application/json',
                'Accept-Language': "fa",
                apikey: process.env.NEXT_PUBLIC_API_KEY + ''
            }
        })
        const exchangeRateResponse: ExchangeRateResponse = await data.json()
        if (exchangeRateResponse.data && exchangeRateResponse.data.results && exchangeRateResponse.data.results.length > 0) {
            setUserScore(`${exchangeRateResponse.data.total_point??"?"}`);
        }
    }

    useEffect(() => {
        if (isLogin) {
            getScore();
        }
    }, [isLogin]);

    function showLoginPage(isLoginState: boolean) {
        if (isLoginState) {
            return () => {
                props.closeDrawer();
                dispatch(loginState({state: LOGIN_STATE, openLoginPage:true}));
            };
        } else {
            return () => {
                props.closeDrawer();
                dispatch(logoutState(LOGOUT_STATE));
            };
        }
    }

    function favoriteClick() {
        props.closeDrawer();
        if (isLogin) {
            router.push(FAVORITE+`?shTitle=${t('favorite')}`);
        } else {
            dispatch(loginState({state: LOGIN_STATE, openLoginPage:true}));
        }
    }

    return (
        <Column className={"h-screen overflow-hidden"}>
            <div className="flex flex-col">
                <Column className="py-2 relative">
                    <img alt={''} src={DRAWER_FRAME_IMAGE} className={'absolute right-0 left-0 top-0'} />
                    <div className="w-full flex flex-row px-4 mb-4 items-center pointer h-36 z-30">
                        {(`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() !== ENGLISH_APP)?<Row>
                            <img alt="" src={USER_PROFILE_FILL_IMAGE} className="userProfileImage ms-2" />
                            {isLogin ? (
                                <Row className="items-center">
                                    <div className="text-white text-bold text-base ms-2 grow px-2">{toPersianNumber(getPhoneNumber())}</div>
                                    <img alt={''} src={USER_LOGOUT_IMAGE} className={'!w-10 p-3'} onClick={showLoginPage(false)} />
                                </Row>
                            ) : (
                                <Row className="items-center ">
                                    <img alt="" src={USER_LOGIN_IMAGE} className="defaultImage" onClick={showLoginPage(true)} />
                                    <div className="mTextLightBlue text-bold text-sm w-full" onClick={showLoginPage(true)}>
                                        {t('profile.loginToAccount')}
                                    </div>
                                </Row>
                            )}
                        </Row>:null}
                    </div>
                    {isLogin?
                        (`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() !== ENGLISH_APP)?<Column className={'relative h-20 justify-center'}>
                            <img alt={''} src={COIN_DRAWER_FRAME_IMAGE} className={'absolute mx-2'} style={{ width: '15rem' }} />
                            <Column className={'z-30 px-8'}>
                                <div className={'text-white text-sm'}>{t('clubText.myScore')}</div>
                                <div className="flex flex-row w-auto mt-2">
                                    <img alt={''} src={COIN_IMAGE} className="littleCoinImage" />
                                    <div className="text-base mx-3 text-white">{toPersianNumber(userScore ?? '?')}</div>
                                </div>
                            </Column>
                        </Column>:null
                        :null}
                    <TitleImageRowComponent
                        title={t('favoriteTools')}
                        image={USER_FAVORITE_IMAGE}
                        onClick={() => favoriteClick()}
                    />
                    <TitleImageRowComponent
                        title={t('setting')}
                        image={USER_SETTING_IMAGE}
                        onClick={() => {
                            props.closeDrawer();
                            router.push(SETTING);
                        }}
                    />
                </Column>
            </div>
        </Column>
    );
}